import { useEffect, useId, useRef, useState } from 'react'
import { getProducts, getServices } from '../../db/api.js'

export default function ChatCatalogItem({ type, onChange }) {
  const listId = useId()
  const input = useRef(null)
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [retry, setRetry] = useState(0)
  const [query, setQuery] = useState('')
  const [open, setOpen] = useState(false)
  const [highlight, setHighlight] = useState(0)
  const [selected, setSelected] = useState(null)
  const [price, setPrice] = useState('')
  const [description, setDescription] = useState('')
  const [period, setPeriod] = useState('mensal')
  const [quantidade, setQuantidade] = useState('1')
  const normalize = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
  const filtered = items.filter((item) => normalize(`${item.nome} ${item.sku || ''}`).includes(normalize(query)))
  useEffect(() => {
    onChange?.({
      itemId: selected?.id || null,
      descricao: description,
      quantidade: Number(quantidade) || 1,
      precoUnitario: Number(price) || 0,
      periodicidade: type === 'servi\u00e7o' ? period : null,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected, description, quantidade, price, period, type])
  useEffect(() => {
    let cancelled = false
    setLoading(true); setError('')
    ;(type === 'produto' ? getProducts() : getServices()).then((rows) => {
      if (!cancelled) setItems(rows)
    }).catch((e) => { if (!cancelled) setError(e.message || 'Não foi possível carregar o catálogo.') })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [type, retry])
  useEffect(() => { input.current?.setCustomValidity(selected ? '' : 'Escolha um item cadastrado na lista.') }, [selected])
  const choose = (item) => {
    setSelected(item); setQuery(item.nome); setPrice(item.preco ?? '')
    setDescription(item.descricao || ''); setPeriod(item.periodicidade || 'mensal'); setOpen(false)
  }
  return <div className="pl-chat-catalog">
    <label>{type === 'produto' ? 'Produto' : 'Serviço'}</label>
    <div className="pl-chat-catalog-search" onBlur={(event) => { if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false) }}>
      <input ref={input} role="combobox" aria-label={type === 'produto' ? 'Buscar produto' : 'Buscar serviço'} aria-autocomplete="list" aria-expanded={open} aria-controls={listId} aria-activedescendant={open && filtered[highlight] ? `${listId}-${highlight}` : undefined}
        required autoComplete="off" placeholder={loading ? 'Carregando catálogo…' : `Buscar ${type} cadastrado…`} value={query}
        onFocus={() => { setOpen(true); setHighlight(0) }} onClick={() => setOpen(true)}
        onChange={(event) => { setQuery(event.target.value); setSelected(null); setPrice(''); setDescription(''); setHighlight(0); setOpen(true) }}
        onKeyDown={(event) => {
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); setOpen(true); setHighlight((index) => Math.max(0, Math.min(filtered.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)))) }
          if (event.key === 'Enter' && open) { event.preventDefault(); if (filtered[highlight]) choose(filtered[highlight]) }
          if (event.key === 'Escape' && open) { event.stopPropagation(); setOpen(false) }
        }} />
      {open && <div className="pl-chat-catalog-options" id={listId} role="listbox" aria-label="Itens cadastrados">
        {loading ? <p>Carregando…</p> : error ? <p>{error}</p> : !filtered.length ? <p>Nenhum {type} encontrado.</p> : filtered.map((item, index) => <div key={item.id} id={`${listId}-${index}`} role="option" aria-selected={selected?.id === item.id} className={index === highlight ? 'is-highlighted' : ''} onMouseDown={(event) => event.preventDefault()} onClick={() => choose(item)}><span>{item.nome}</span><small>{Number(item.preco || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}{type === 'serviço' ? ` · ${item.periodicidade}` : item.sku ? ` · ${item.sku}` : ''}</small></div>)}
      </div>}
    </div>
    {error && <button type="button" onClick={() => setRetry((n) => n + 1)}>Recarregar catálogo</button>}
    <label>Descrição<textarea rows={2} value={description} onChange={(event) => setDescription(event.target.value)} /></label>
    <div className="pl-chat-item-values"><label>Quantidade<input type="number" min="1" step="1" value={quantidade} onChange={(event) => setQuantidade(event.target.value)} required /></label><label>Valor unitário (R$)<input type="number" min="0" step="0.01" value={price} onChange={(event) => setPrice(event.target.value)} required /></label></div>
    {type === 'serviço' && <label>Periodicidade<select value={period} onChange={(event) => setPeriod(event.target.value)}>{['unico', 'mensal', 'trimestral', 'semestral', 'anual'].map((value) => <option key={value} value={value}>{({ unico: 'Único', mensal: 'Mensal', trimestral: 'Trimestral', semestral: 'Semestral', anual: 'Anual' })[value]}</option>)}</select></label>}
  </div>
}
